module.exports = __webpack_public_path__ + "img/map-pointer.ce976d0e.svg";